module.exports = __webpack_public_path__ + "static/img/step-4.e29130bd.png";